import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface PropTypes {
    legendItems: {
        color: string;
        label: string;
    }[];
}

function CalendarLegend({ legendItems }: PropTypes) {
    return (
        <Box display="flex" flexDirection="column">
            {legendItems.map((item, index) => (
                <Box key={index} display="flex" alignItems="center" mb={1}>
                    <Box
                        width={20}
                        height={20}
                        bgcolor={item.color}
                        borderRadius={1}
                        mr={2}
                    />
                    <Typography variant="body1">{item.label}</Typography>
                </Box>
            ))}
        </Box>
    );
}

export default CalendarLegend;